import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-welcome-message',
  standalone: true,
  imports: [CommonModule, RouterModule, AvatarModule, ButtonModule],
  template: `
    <div class="welcome-container">
      <div class="welcome-header">
        <p-avatar
          label="PP"
          shape="circle"
          size="normal"
          styleClass="patty-avatar"
          [routerLink]="['/pathway-patty']"
          [style]="{ cursor: 'pointer' }"
        ></p-avatar>
        <div class="welcome-header-text">
          <a class="welcome-title" [routerLink]="['/pathway-patty']"
            >Welcome from Pathway Patty!</a
          >
          <div class="welcome-subtitle">Your personalized career guide</div>
        </div>
      </div>
      <div class="welcome-content">
        <p>{{ message }}</p>
        <div class="welcome-action" *ngIf="recommendedCategory">
          <button
            pButton
            type="button"
            [label]="'Explore ' + displayCategory"
            icon="pi pi-arrow-right"
            (click)="onCategoryClick()"
            class="category-button"
          ></button>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .welcome-container {
        background-color: #ffffff;
        border-radius: 8px;
        padding: 1.5rem;
        margin-bottom: 1rem;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      }

      .welcome-header {
        display: flex;
        align-items: center;
        gap: 1rem;
        margin-bottom: 1rem;
        padding-bottom: 1rem;
        border-bottom: 1px solid #e5e5e5;
      }

      .welcome-header-text {
        flex: 1;
      }

      .welcome-title {
        font-weight: 600;
        font-size: 1rem;
        color: #0066cc;
        margin-bottom: 0.25rem;
        text-decoration: none;
        display: inline-block;
        transition: color 0.2s ease;
      }

      .welcome-title:hover {
        color: #0052a3;
        text-decoration: underline;
      }

      .welcome-subtitle {
        font-size: 0.85rem;
        color: #666666;
      }

      .welcome-content {
        color: #333333;
        line-height: 1.6;
      }

      .welcome-content p {
        margin: 0 0 1rem 0;
      }

      .welcome-action {
        margin-top: 1rem;
      }

      .category-button {
        background: #0066cc;
        color: #ffffff;
        border: none;
      }

      :host ::ng-deep {
        .patty-avatar {
          background-color: #ff6b6b;
          color: #ffffff;
          font-weight: 600;
        }
      }
    `,
  ],
})
export class WelcomeMessageComponent implements OnInit, OnChanges {
  @Input() message: string = '';
  @Input() recommendedCategory: string = '';
  @Input() onCategorySelect: ((category: string) => void) | null = null;

  displayCategory: string = '';

  ngOnInit() {
    this.randomizeButtonCategory();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.randomizeButtonCategory();
  }

  private randomizeButtonCategory() {
    const categories = ['Construction', 'Medical', 'IT'];
    const randomIndex = Math.floor(Math.random() * categories.length);
    this.displayCategory = categories[randomIndex];
  }

  onCategoryClick() {
    if (this.onCategorySelect) {
      this.onCategorySelect(this.displayCategory);
    }
  }
}
